import React from 'react';
import { Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';

/**
 * Get statistics from y4 api
 * @param {*} param0
 * @returns
 */
const StatisticsPanel = ({ statistics }) => {
  return (
    !_.isEmpty(statistics) && (
      <>
        <hr />
        <Row>
          {statistics.map((st, index) => {
            const v = isNaN(st.value) ? '' : st.value;
            return (
              <Col key={index} sm={12} md={6} xl={4} xxl={3}>
                <InputGroup className="mb-3">
                  <InputGroup.Text>{st.name}</InputGroup.Text>
                  <FormControl aria-label={st.name} value={v} readOnly />
                </InputGroup>
              </Col>
            );
          })}
        </Row>
      </>
    )
  );
};

StatisticsPanel.propTypes = {
  statistics: PropTypes.array
};

export default StatisticsPanel;
